import { useState } from 'react';
import { FolderOpen } from 'lucide-react';

export default function InlineNotebookPicker({ selectedNote, notebooks, updateNote, selectedNoteId }) {
  const [showPicker, setShowPicker] = useState(false);
  const noteNotebook = notebooks.find((nb) => nb.id === selectedNote.notebook_id);

  const handleNotebookChange = async (notebookId) => {
    if (!selectedNote) return;
    await updateNote(selectedNoteId, { notebook_id: notebookId });
    setShowPicker(false);
  };

  return (
    <>
      <button
        onClick={() => setShowPicker(!showPicker)}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs rounded-md border transition-colors ${
          noteNotebook
            ? 'border-accent-amber/30 bg-accent-amber/10 text-accent-amber'
            : 'border-border/50 text-muted-foreground hover:border-border hover:bg-muted/30'
        }`}
        data-testid="editor-inline-notebook-btn"
      >
        <FolderOpen className="w-3.5 h-3.5" />
        <span className="max-w-[120px] truncate">{noteNotebook ? noteNotebook.name : 'Add to Notebook'}</span>
      </button>

      {showPicker && (
        <div className="w-full mt-3 p-3 rounded-lg border border-border bg-secondary/30 animate-fade-in" data-testid="editor-notebook-picker">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-medium text-muted-foreground">Select Notebook</span>
            <button
              onClick={() => setShowPicker(false)}
              className="text-xs text-muted-foreground hover:text-foreground p-1"
              data-testid="editor-notebook-picker-close"
            >
              Done
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => { handleNotebookChange(null); setShowPicker(false); }}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-md border transition-colors min-h-[32px] ${
                !selectedNote.notebook_id
                  ? 'border-accent-amber/50 bg-accent-amber/10 text-accent-amber'
                  : 'border-border text-muted-foreground hover:bg-muted/30'
              }`}
              data-testid="editor-notebook-none"
            >
              <FolderOpen className="w-3.5 h-3.5" />
              No Notebook
              {!selectedNote.notebook_id && (
                <svg className="w-3 h-3 ml-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </button>
            {notebooks.map((nb) => (
              <button
                key={nb.id}
                onClick={() => { handleNotebookChange(nb.id); setShowPicker(false); }}
                data-testid={`editor-notebook-pick-${nb.id}`}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-md border transition-colors min-h-[32px] ${
                  selectedNote.notebook_id === nb.id
                    ? 'border-accent-amber/50 bg-accent-amber/10 text-accent-amber'
                    : 'border-border text-muted-foreground hover:bg-muted/30'
                }`}
              >
                <FolderOpen className="w-3.5 h-3.5" />
                {nb.name}
                {selectedNote.notebook_id === nb.id && (
                  <svg className="w-3 h-3 ml-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
            ))}
            {notebooks.length === 0 && (
              <span className="text-xs text-muted-foreground py-2">No notebooks yet. Create one from the sidebar.</span>
            )}
          </div>
        </div>
      )}
    </>
  );
}
